module.exports = __webpack_public_path__ + "media/images/icon-user-menu-f2c27592700cc2334cb0eec7eeddd3d9.svg";